// Imports ------------------------------------------------------------------->

import { inject } from '../di'
import { ILoyaltyCardProvider } from '../definitions/ILoyaltyCardProvider'
import { LoyaltyCardJSON } from '../../definitions/CommonDefinitions'
import { AuthUser } from '../definitions/IAuthenticationService'
import { AccountsService } from '../AccountsService'
import { PostcardService, SessionJSON } from '../PostcardService'
import * as array from '../../utils/array'

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export class DefaultCardProvider implements ILoyaltyCardProvider {
    @inject accountsService: AccountsService
    @inject postcardService: PostcardService

    private _loyaltyCardsJSON: Promise<LoyaltyCardJSON>

    getLoyaltyCards(user: AuthUser) {
        if (!this._loyaltyCardsJSON) {
            /* First time loyalty cards are requested, we need to call start_session
             * in Postcard to get the current status */
            this._loyaltyCardsJSON = new Promise((resolve) => {
                /* Step 1: Call Accounts API to fetch saved loyalty cards*/
                this.accountsService
                    .getLoyaltyCards(user.token)
                    .then((cards: LoyaltyCardJSON) => {
                        /* Step 2: Call start_session on Postcard API to verify the status
                         * of each loyalty card*/
                        this.postcardService
                            .startSession(user.token.user_id, cards)
                            .then((session: SessionJSON) => {
                                /* Step 3: Cycle through each card returned from start_session and
                                 * update the registered/token field in the resulting metadata */
                                session.cards.forEach((sessionCard) => {
                                    const matchedCard = array.find(
                                        cards.loyalty_cards,
                                        (card) =>
                                            card.loyalty_program_id ===
                                            sessionCard.loyalty_program_id
                                    )
                                    if (matchedCard) {
                                        matchedCard.registered =
                                            sessionCard.registered
                                        matchedCard.token = sessionCard.token
                                    } else {
                                        /* Card missing from Postcard? Assume not registered */
                                        matchedCard.registered = false
                                    }
                                })

                                resolve(cards)
                            })
                            .catch(() => {
                                /* Handle postcard error. Mark each card as unregistered so they appear
                                 * as 'unavailable' in the UI */
                                cards.loyalty_cards.forEach((card) => {
                                    card.registered = false
                                })
                                resolve(cards)
                            })
                    })
                    .catch(() => {
                        resolve({ loyalty_cards: [] })
                    })
            })
        }
        return this._loyaltyCardsJSON
    }

    clear() {
        this._loyaltyCardsJSON = null
    }
}
